const signinRedirectKey = '_coinbase_signin_redirect';
const setSigninRedirect = path => {
  let pathname = path;
  if (!pathname) {
    pathname = typeof window !== 'undefined' ? window.location.pathname : '';
  }
  localStorage.setItem(signinRedirectKey, pathname);
};
export { setSigninRedirect as default };
//# sourceMappingURL=setSigninRedirect.js.map
